type Owner='recognition'|'welcome'|'onboarding';
type Snapshot={version:number;blocked:boolean;owner:Owner|null;returnLabel:string;returnLabelAt:number};
export class PresentationCoordinator {
 private holds=new Map<symbol,string>();
 private listeners=new Set<()=>void>();
 private current:Snapshot={version:0,blocked:false,owner:null,returnLabel:'Back to the map',returnLabelAt:0};
 getSnapshot=()=>this.current;
 subscribe=(listener:()=>void)=>{this.listeners.add(listener);return()=>{this.listeners.delete(listener);};};
 private update(patch:Partial<Snapshot>={}){this.current={...this.current,...patch,blocked:this.holds.size>0,version:this.current.version+1};this.listeners.forEach(listener=>listener());}
 hold(label='Back to the map'){
  const id=Symbol();this.holds.set(id,label);this.update();let released=false;
  return()=>{if(released)return;released=true;const label=this.holds.get(id);this.holds.delete(id);this.update(label?{returnLabel:label,returnLabelAt:Date.now()}:{});};
 }
 claim(owner:Owner){if(this.current.blocked||this.current.owner)return null;this.update({owner});let released=false;return()=>{if(!released){released=true;this.update({owner:null});}};}
}
export const presentations=new PresentationCoordinator();
